import React, { useRef } from "react";
import PropTypes from "prop-types";
import ColourPicker from "@visiblethread/react-components/dist/components/ColourPicker";
import { useDispatch } from "react-redux";
import {
  validateCategories,
  validateTerms,
  changeCategoryColour,
} from "slices/dictionary/dictionarySlice";
import { doesTableContainActiveElement } from "@visiblethread/react-components/dist/utils/table";

const Colour = ({ categoryId, termId, colour, disabled, isSelected }) => {
  const wrapperRef = useRef(null);
  const dispatch = useDispatch();

  const handleColourPickerFocus = (colourPicker) => {
    if (!doesTableContainActiveElement()) return;

    if (isSelected) {
      colourPicker?.focus({ preventScroll: true });
    }

    if (!isSelected && document.activeElement === colourPicker) {
      wrapperRef?.current?.focus({ preventScroll: true });
    }
  };

  const handleColourChange = (newColour) => {
    dispatch(changeCategoryColour({ categoryId, termId, colour: newColour }));

    dispatch(validateCategories());
    dispatch(validateTerms());
  };

  return (
    <div
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex={0}
      ref={wrapperRef}
      className={`colour_cell${isSelected ? " selected" : ""}`}
      data-testid="colour-cell"
    >
      <ColourPicker
        selectedColour={colour}
        setSelectedColour={handleColourChange}
        disabled={disabled}
        colourPickerRef={handleColourPickerFocus}
      />
    </div>
  );
};

Colour.defaultProps = {
  disabled: false,
  isSelected: false,
};

Colour.propTypes = {
  categoryId: PropTypes.number.isRequired,
  termId: PropTypes.number,
  /**
   * Colour which colour picker will display.
   */
  colour: PropTypes.string.isRequired,
  /**
   * If true, widget becomes uninteractable.
   */
  disabled: PropTypes.bool,
  /**
   * Equals true if this cell is selected. Provided by table. You shouldn't pass this prop.
   */
  isSelected: PropTypes.bool,
};

export default Colour;
